import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';
import { useCreateServicePlanTerm } from 'src/features/servicePlanTerms/api/useCreateServicePlanTerm';
import { LIST_SERVICE_PLAN_TERMS_RESOURCE } from 'src/features/servicePlanTerms/api/useListServicePlanTerms';
import { servicePlanTermsMessages } from 'src/features/servicePlanTerms/utils/messages';
import ServicePlanTermFormModal from 'src/features/servicePlanTerms/components/forms/ServicePlanTermFormModal';
import { useParams } from 'react-router-dom';
import { SERVICE_PLAN_RESOURCE } from 'src/features/servicePlans/api/useGetServicePlan';

interface CreateServicePlanTermFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanTerm?: ServicePlanTerm;
    children?: React.ReactNode;
}

function CreateServicePlanTermFormModal<TData>({ className, semantics }: CreateServicePlanTermFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { servicePlanId = '' } = useParams();

    const { mutate, isPending } = useCreateServicePlanTerm({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_TERMS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [SERVICE_PLAN_RESOURCE] });
            toast({
                title: formatMessage(servicePlanTermsMessages.createServicePlanTermSuccess),
                description: formatMessage(servicePlanTermsMessages.createServicePlanTermSuccessDescription),
            });
        },
    });

    return (
        <ServicePlanTermFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, servicePlanId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(servicePlanTermsMessages.addServicePlanTermSubtitle)}
        />
    );
}

export default CreateServicePlanTermFormModal;
